import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { json } from './assets/json'
Vue.use(Router)

export const routes = [{
  path: '/',
  name: 'home',
  titulo: 'Home',
  nav: true,
  component: Home
},
{
  path: '/aclinica',
  name: 'aclinica',
  titulo: 'A clinica',
  nav: false,
  component: () => import('./views/AClinica.vue')
},
{
  path: '/tratamentos',
  name: 'tratamentos',
  titulo: 'Tratamentos',
  classes: 'ui dropdown simple',
  dropdown: json,
  nav: true,
  component: () => import('./views/Tratamentos.vue')
},
{
  path: '/tratamento/:id',
  name: 'tratamento',
  titulo: '',
  nav: false,
  component: () => import('./views/Tratamentos.vue')
},
{
  path: '/Agendamento',
  name: 'Agendamento',
  titulo: 'Agendamento',
  nav: false,
  component: () => import('./views/Agendamento.vue')
}, {
  path: '/contato',
  name: 'contato',
  titulo: 'Contato',
  nav: true,
  component: () => import('./views/Contato.vue')
}
];
export default new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from) {
    return { x: 0, y: 0 }
  }

})
